{
  "$schema": "https://mux.run/theme.json",
  "name": "Rose Pine",
  "id": "rosepine",
  "light": {
    "palette": {
      "neutral": "#faf4ed",
      "ink": "#575279",
      "primary": "#31748f",
      "accent": "#d7827e",
      "success": "#286983",
      "warning": "#ea9d34",
      "error": "#b4637a",
      "info": "#56949f"
    },
    "overrides": {
      "text-weak": "#9893a5",
      "syntax-comment": "#9893a5",
      "syntax-keyword": "#286983",
      "syntax-string": "#ea9d34",
      "syntax-primitive": "#d7827e",
      "syntax-variable": "#575279",
      "syntax-property": "#d7827e",
      "syntax-type": "#56949f",
      "syntax-constant": "#907aa9",
      "syntax-operator": "#797593",
      "syntax-punctuation": "#797593",
      "syntax-object": "#575279",
      "markdown-heading": "#907aa9",
      "markdown-text": "#575279",
      "markdown-link": "#31748f",
      "markdown-link-text": "#d7827e",
      "markdown-code": "#286983",
      "markdown-block-quote": "#9893a5",
      "markdown-emph": "#ea9d34",
      "markdown-strong": "#b4637a",
      "markdown-horizontal-rule": "#dfdad9",
      "markdown-list-item": "#31748f",
      "markdown-list-enumeration": "#d7827e",
      "markdown-image": "#31748f",
      "markdown-image-text": "#d7827e",
      "markdown-code-block": "#575279"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#191724",
      "ink": "#e0def4",
      "primary": "#9ccfd8",
      "accent": "#ebbcba",
      "success": "#31748f",
      "warning": "#f6c177",
      "error": "#eb6f92",
      "info": "#9ccfd8"
    },
    "overrides": {
      "text-weak": "#6e6a86",
      "syntax-comment": "#6e6a86",
      "syntax-keyword": "#31748f",
      "syntax-string": "#f6c177",
      "syntax-primitive": "#ebbcba",
      "syntax-variable": "#e0def4",
      "syntax-property": "#ebbcba",
      "syntax-type": "#9ccfd8",
      "syntax-constant": "#c4a7e7",
      "syntax-operator": "#908caa",
      "syntax-punctuation": "#908caa",
      "syntax-object": "#e0def4",
      "markdown-heading": "#c4a7e7",
      "markdown-text": "#e0def4",
      "markdown-link": "#9ccfd8",
      "markdown-link-text": "#ebbcba",
      "markdown-code": "#31748f",
      "markdown-block-quote": "#6e6a86",
      "markdown-emph": "#f6c177",
      "markdown-strong": "#eb6f92",
      "markdown-horizontal-rule": "#403d52",
      "markdown-list-item": "#9ccfd8",
      "markdown-list-enumeration": "#ebbcba",
      "markdown-image": "#9ccfd8",
      "markdown-image-text": "#ebbcba",
      "markdown-code-block": "#e0def4"
    }
  }
}
